import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { EnvironmentProviders } from '@angular/core';
import { organizationContextInterceptor } from './organization-context.interceptor';

/** Keep the generation boundary outside the asynchronous legacy MSAL chain. */
export function providePortalHttpClient(): EnvironmentProviders {
  return provideHttpClient(withInterceptors([organizationContextInterceptor]), withInterceptorsFromDi());
}
